<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-2 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  Kubo
                  <span>Extensión de word</span>
                </h1>
                <p class="lead  text-white">                  
                      Integrando <b>TODA</b> la potencia de NOTIN en el interior de su procesador de textos favorito.
                </p>
                <div class="btn-wrapper">
                  <!-- <p class="lead text-white">
                    This web app can be generated in Vue.js combined with
                    Express / Flask or Laravel. Your choice :)
                  </p> -->
                  <a
                    target="_blank"
                    href="#"
                    class="btn btn-white btn-icon mb-3 mb-sm-0"
                    v-scroll-to="'#contacto'"
                  >
                    <i style="color: red" class="fa fa-rocket"></i>
                    <span class="btn-inner--text"
                      >Solicitar Demo</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <div  class="parallax-container mt--150">
      <parallax fixed>
        <img :src="'img/bg_kubo.jpg'"/>
      </parallax>
    </div>
    <!-- <ParallaxImage class="mt-2" :src="'img/sc_kubo.jpg'"/> -->
    <div class="profile-page">
      <section class="section section-skew">
        <div class="container">
          <card shadow class="card-profile mt--300" no-body>
            <div class="px-4">
              <div class="row justify-content-center">
                <div class="col-lg-3 order-lg-2">
                  <div class="card-profile-image">
                    <a href="#">
                      <img
                        v-lazy="'img/sq_kubo.png'"
                        class="rounded-circle rounded-notin bg-white"
                      />
                    </a>
                  </div>
                </div>
                <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
        
                </div>
                <div class="col-lg-4 order-lg-1">
                  <div class="card-profile-stats d-flex justify-content-center">
                
                  </div>
                </div>
              </div>
              <div class="row">
                  <div class="col-lg-12 text-center mt-5"><br><br><br>
                      <h1>
                          Kubo
                      </h1>
                  </div>
              </div>
              <div class="mt-5 py-5 border-top text-justify">
                <div class="row justify-content-center">
                  <div class="col-lg-12 mx-0">
                    <p>
                      Herramienta que se integra nativamente en el procesador de texto Microsoft Word de la suite Office, para trabajar con cualquier documento notarial, asociando toda la potencia de gestión de la datos y textos automatizados que NOTIN proporciona.
                      Lo mejor de ambos mundos, procesador de texto avanzado y gestión de los datos, reunidos en una sola pieza.
                    </p>
                    </div>
                <div class="row">
                    <div class="col-lg-12 mb-4 px-5">
                      <h3>Funcionalidades</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 mb-4 px-5">
                      <ul class="list-unstyled mt-2">
                          
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-blue text-white"
                              icon="fa fa-book"
                              ></badge>
                              <h6 class="mb-0">Escrituras</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-purple text-white"
                              icon="fa fa-book "
                              ></badge>
                              <h6 class="mb-0">Pólizas</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-indigo text-white"
                              icon="fa fa-book "
                              ></badge>
                              <h6 class="mb-0">Legitimaciones</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-folder-open "
                              ></badge>
                              <h6 class="mb-0">Expedientes</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3"
                              icon="fa fa-user"
                              ></badge>
                              <h6 class="mb-0">Clientes</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-pink text-white"
                              icon="fa fa-calendar"
                              ></badge>
                              <h6 class="mb-0">Agenda</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-yellow text-white"
                              icon="fa fa-tasks"
                              ></badge>
                              <h6 class="mb-0">Tareas</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-blue text-white"
                              icon="fa fa-spell-check"
                              ></badge>
                              <h6 class="mb-0">Parser</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-red text-white"
                              icon="fa fa-cogs"
                              ></badge>
                              <h6 class="mb-0">Automatización de textos</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-indigo text-white"
                              icon="fa fa-print"
                              ></badge>
                              <h6 class="mb-0">Impresión inteligente</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-plus "
                              ></badge>
                              <h6 class="mb-0">Y próximamente mucho más... </h6>
                          </div>
                          </li>
                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <img class="w100 bg-blue pt-2 pb-2 pl-2 pr-2" v-lazy="'img/ecosistema.png'"/>
                    </div>
                    <!-- <a href="#">Show more</a> -->
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>
  
    <section class="section section section-shaped my-0 overflow-hidden bg-gris pb-200">
      <div class="shape shape-style-1 bg-gradient-warning shape-skew zindex0">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-5">
              <img src="img/ill/ill-2.svg" class="img-center img-fluid" />
            </div>
          </div>
          <div class="col-lg-6 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon
                  name="ni ni-building"
                  size="lg"
                  class="bg-gradient-white"
                  color="primary"
                  shadow
                  rounded
                ></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3 text-white">Interfaz productiva</h4>
                <p class="text-white">
                  Diseñada para ofrecer teclas directas a funcionalidades complejas de trabajo. Optimizado para operaciones de arrastre de elementos sobre el documento y sobre otros elementos. Varias acciones se realizan en segundo plano mientras usted puede seguir escribiendo en el documento.
                </p>
              </div>
            </div>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-satisfied"
                    gradient="success"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-success">Soporte Técnico</h5>
                  <p>
                    Nuestro equipo de soporte técnico estará disponible siempre que nos necesite.
                  </p>
                  <a href="#" class="text-success">Más información</a>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-active-40"
                    gradient="warning"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-warning">NOTIN Academy</h5>
                  <p>
                    Realizamos <b>Talleres de Formación OnLine</b>, videos de <b>Cursos Express</b> y documentación detallada de nuestros productos.
                  </p>
                  <a href="#" class="text-warning">Más Información</a>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
    
  </div>
</template>

<script>

export default {
  name: "hash",
    components:{
        ParallaxImage: () => import("../components/ParallaxImage.vue"),
        Parallax: () => import('vue-parallaxy'),
    }

};
</script>
<style scoped>

</style>